import React from 'react'
import $ from 'jquery';
import '../Styles/About.css'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import FeatureSection from '../Components/FeatureSection'
import HappyClients from '../Components/HappyClients'
import BottomCarousel from '../Components/BottomCarousel'

function About() {
   $(document).ready(function(){
      $('.customer_carousel2').owlCarousel({
        loop:true,
        margin:0,
        
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        nav:false,
        dots:true,
        responsive:{
            0:{
                items:1
            },
            320:{
                items:1
            },
            480:{
                items:1
            },
            600:{
                items:1
            },
            767:{
                items:1
            },
            991:{
                items:1
            },
            1200:{
                items:2
            }
        }
    });
    });	
$(document).ready(function(){
$('.owl-carousel').owlCarousel({
items: 10, // Number of items visible at once
loop: true, // Loop the carousel
margin: 10, // Space between items
autoplay: true, // Autoplay the carousel
autoplayTimeout: 3000, // Autoplay interval in milliseconds
responsive: {
0: {
items: 1
},
768: {
items: 2
},
1024: {
items: 4
}
}
});
});
return (
<div className="App">
<header className="header">
    
      <div className='backgroung-image'>
        <Navbar/>
      <div className='header-about-content'>
         <h1>Hear Our Story</h1>
      </div>
      </div>
   </header>
   <main className="main">
        <section className='container about-success'>
             <div className='about-success-work'>
             <h2 className="what-we-dosss"><span className="what-we-dossss">Success</span> Work</h2>
            <p>BRiX Network Pvt Ltd is a pure play Knowledge Transfer Organization, was incorporated in November 2014,
            with ATP feature from extreme networks for PAN India. BRiX thrives in setting a benchmark in the Knowledge
            Transfer Domain and its Services by building a strong Business Compliance awareness team on its designated
            vertical delivery to its clientele, with an objective of ensuring value based, high quality and future-proof
            services. BRiX Networks has identified and partnered with world’s leading life science organization | OEMs for 
            their Authorised Training Partner & Authorised Learning Center | Empaneled Subject Matter Experts | Lead auditors 
            | Cyber Security Experts. </p>
            <p>BRiX Networks has partnered with a few of India’s top private, Science, Engineering Universities & Business
               Schools through its subsidiary company VEDAM Network Academy in association with SoSE™, to upskill student
                community as part of the industry and academic collaboration initiative, by setting up its Knowledge Transfer
                 Center (KTC), enabled with real presence, connected over Domestic MPLS backhaul. </p>
            <p>In addition, BRiX would provide Domain Compliance Program and industry best practice services to its associates
             – System Integrators | Technology Institutions | Distributors | OEMs .</p>
             </div>
        </section>
        <section className="features">
         <div className="mt-5">
            <div className="hwhatwedo">
               <div className="container ">
                  <h2 className="what-we-dos"><span className="what-we-do">What</span> We Do</h2>
                  <hr className="animated-hrs" />
               </div>
            </div>
         </div>
         <FeatureSection/>
      </section>
     {/* Happy Clients Start */}
     <section className='Happy-clients'>
          <HappyClients/>
       </section>
      {/* Happy Clients END */}
      {/* Brand Section Start */}
      <BottomCarousel/>
      {/* Brand Section end */}

   </main>
      {/* <!------footer start--------> */}
      <Footer/>
{/* <!------footer end--------> */}
</div>
);
}
export default About;